import { axios } from 'system/axios'

export const sendVerificationEmail = () => axios.post<unknown>('/validate')
